import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import moment from 'moment';
import { DataKeyValues, SemanticValues, TranslationIdValues } from '../../diagnostics-constants';

@Component({
  selector: 'app-vdd-date-readonly',
  templateUrl: './vdd-date-readonly.component.html',
  styleUrls: ['./vdd-date-readonly.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VddDateReadonlyComponent implements OnInit {
  @Input() matchedValues: any[];
  @Input() skipIndexes: number[];
  @Input() index: number;
  isFullDate = true;
  dayValue: any;
  monthValue: any;
  yearValue: any;
  skippedIndexes: number[] = [];
  datepickerDate: FormControl<Date>;
  firstValueType: TranslationIdValues;
  translationIdsToCheck = [
    TranslationIdValues.Day,
    TranslationIdValues.Month,
    TranslationIdValues.Year,
  ];

  ngOnInit(): void {
    this.firstValueType = this.matchedValues[this.index][DataKeyValues.TranslationId];
    this.skippedIndexes.push(this.index);
    this.getAllDateData();
    this.datepickerDate = new FormControl<Date>({ value: null, disabled: true });
    if (this.dayValue && this.monthValue && this.yearValue) {
      const dateString = `${this.yearValue.value}-${this.monthValue.value}-${this.dayValue.value}`;
      const momentDate = moment(dateString, 'YY-MM-DD');
      this.datepickerDate.setValue(momentDate.toDate());
    } else {
      this.isFullDate = false;
    }
  }

  private getAllDateData(): void {
    for (let i = this.index; i < this.matchedValues.length; i++) {
      const value = this.matchedValues[i];

      if (i > this.index && this.firstValueType === value[DataKeyValues.TranslationId]) {
        break;
      }

      if (
        this.translationIdsToCheck.includes(value?.translationid) &&
        value?.semantic !== SemanticValues.DESCRIPTION
      ) {
        if (i > this.index) {
          this.skipIndexes.push(i);
          this.skippedIndexes.push(i);
        }
        switch (value?.[DataKeyValues.TranslationId]) {
          case TranslationIdValues.Day: {
            this.dayValue = this.matchedValues[i];
            break;
          }
          case TranslationIdValues.Month: {
            this.monthValue = this.matchedValues[i];
            break;
          }
          case TranslationIdValues.Year: {
            this.yearValue = this.matchedValues[i];
            break;
          }
        }
      } else {
        break;
      }
    }
  }
}
